<template>
  <div class="page_diaobo_wl_add">
    <van-nav-bar title="装车单信息登记" left-text="返回" @click-left="back" />
    <van-form
      class="container"
      @submit="onSubmit"
      :show-error="false"
      :scroll-to-error="true"
    >
      <div class="content c1" :class="showType === 3 ? 'dis' : 'nodis'">
        <h3>物流信息</h3>
        <Select
          v-model="form.logisticsCompany"
          url="/emm/clientInfo/pageList"
          :params="{ clientType: '02',limit: 999 }"
          keys="clientName"
          showName="clientName"
          :required="true"
          label="物流单位："
          :searchMode="true"
        >
        </Select>

        <van-field
          required
          v-model="form.phone"
          label="联系电话："
          placeholder="联系电话"
          :rules="[{ required: true, message: '请填写联系电话' }]"
        />
        <van-field
          v-model="form.driver"
          label="司机姓名："
          placeholder="司机姓名"
          :rules="[{ required: false, message: '请填写司机姓名' }]"
        />

        <van-field
          v-model="form.plateNumber"
          label="车牌号码："
          placeholder="车牌号码"
          :rules="[{ required: false, message: '请填写车牌号码' }]"
        />
        <Select
          v-model="form.carModel"
          url="/system/dict/list/table"
          :params="{ code: 'yscx' }"
          keys="name"
          showName="name"
          :required="false"
          label="运输车型："
        >
        </Select>
        <van-field
          v-model="form.logisticsNumber"
          label="物流运单号："
          placeholder="物流运单号"
          :rules="[{ required: false, message: '请填写物流运单号' }]"
        >
          <template #button v-if="showType < 3">
            <SixNineCode
              ref="ljcode"
              icon="scan"
              size="25"
              :onlyCode="true"
              @commonCode="getljCode"
            ></SixNineCode>
          </template>
        </van-field>
      </div>
      <div class="content c2" :class="showType === 3 ? 'dis' : 'nodis'">
        <h3>车载物资</h3>
        <div class="emm_list_box">
          <van-badge
            v-for="(row, index) in form.transportList"
            :key="index"
            :content="index + 1"
            color="#1989fa"
          >
            <div class="emm_item">
              <Select
                :required="true"
                v-model="form.transportList[index].alias"
                :dataList="myEmmList"
                keys="alias"
                showName="alias"
                label="物资品名："
                @change="emmChange($event, index)"
              >
              </Select>
              <van-field
                v-model="form.transportList[index].brandName"
                label="品牌："
                readonly
              />
              <van-field
                v-model="form.transportList[index].modelName"
                label="型号："
                readonly
              />
              <van-field
                v-model="form.transportList[index].specifications"
                label="辅助属性："
                readonly
              />

              <van-field
                required
                v-model="form.transportList[index].loadNum"
                label="运输数量："
                type="digit"
                placeholder="运输数量"
                :rules="[{ required: true, message: '请填写运输数量' }]"
              />
              <div class="btn_box">
                <van-button
                  v-if="showType !== 3"
                  type="danger"
                  block
                  size="small"
                  icon="delete"
                  native-type="button"
                  color="linear-gradient(to right, #ff6034, #ee0a24)"
                  @click="emmListDel(index)"
                  >删除此物资</van-button
                >
              </div>
            </div>
          </van-badge>
        </div>
        <van-button
          v-if="showType !== 3"
          native-type="button"
          type="info"
          plain
          block
          icon="plus"
          @click="addList"
          >新增</van-button
        >
      </div>
      <div class="content c3">
        <h3>物流发运照片(多张)</h3>
        <Uploader v-model="form.attachments" :disabled="showType === 3"></Uploader>
      </div>
      <van-button
        v-if="showType !== 3"
        round
        block
        type="primary"
        native-type="submit"
        style="width: 80%; margin: 15px auto"
        >提交</van-button
      >
    </van-form>
  </div>
</template>
<script>
export default {
  props: ["showType", "showData", "emmList"],
  watch: {
    emmList() {
      this.myEmmList = this.emmList;
      console.log("wladd", this.myEmmList);
    },
  },
  data() {
    return {
      myEmmList: [],
      form: {
        carModel: "",
        driver: "",
        logisticsCompany: "",
        logisticsNumber: "",
        phone: "",
        plateNumber: "",
        transportList: [],
        attachments: "",
      },
    };
  },
  created() {
    this.myEmmList = this.emmList;
    if (this.showType > 1) {
      this.form = this.showData;
    }
  },
  methods: {
    back() {
      this.$emit("close");
    },
    getljCode(code){
      this.form.logisticsNumber = code
    },
    emmChange(row, index) {
      console.log(row, index);
      this.form.transportList[index].emmCode = row.emmCode;
      this.form.transportList[index].specifications = row.specifications;
      this.form.transportList[index].brandName = row.brandName;
      this.form.transportList[index].modelName = row.modelName;
      this.form.transportList.splice(0, 0);
    },
    addList() {
      this.form.transportList.push({});
    },
    emmListDel(index) {
      let that = this;
      this.$dialog
        .confirm({
          title: "提示",
          message: "确认删除吗？",
        })
        .then(() => {
          that.form.transportList.splice(index, 1);
        });
    },

    onSubmit(values) {
      console.log("submit", values);
      if (this.form.transportList.length < 1) {
        return this.$msg.info("车载物资列表不能为空");
      }
      if (this.showType > 1) {
        this.$emit("addChange", this.form);
      } else {
        this.$emit("addComfirm", this.form);
      }
      this.back();
    },
  },
};
</script>
<style lang="scss">
.page_diaobo_wl_add {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-color: #f6f9f8;
  .container {
    width: 100vw;
    height: calc(100vh - 46px);
    overflow-x: hidden;
    overflow-y: auto;
    .content {
      background: #fff;
      margin: 10px 0;
      padding: 10px 16px;
      h3 {
        margin-bottom: 10px;
      }
      &.c2 {
        background: #f6f9f8;
      }
      .emm_list_box {
        width: 90%;
        margin: 15px auto;
        .van-badge__wrapper {
          width: 100%;
        }
        .emm_item {
          width: 100%;
          margin-bottom: 15px;
          background-color: #fff;
          border-radius: 7px;
          overflow: hidden;
          box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.2);
          .van-cell {
            padding: 5px 16px;
          }
          .btn_box {
            display: flex;
            justify-content: flex-end;
          }
        }
      }
    }
  }
  .van-overlay {
    display: flex;
    justify-content: center;
    align-transportlist: center;
  }
}
</style>